import * as types from './types';


// @TODO I think we can simplify this into a combination of keys in one object
// dialogOpen: false,
// dialogTitle: null,
// dialogMessage: null,
// dialogClassName: null,


export const updateAlertDialog = (payload) => {
  return { type: types.ALERT_DIALOG, payload };
};

export const closeAlertDialog = () => {
  return updateAlertDialog({ open: false });
};

export const openSuccessDialog = (payload) => {
  return updateAlertDialog({
    open: true,
    error: false,
    ...payload,
  });
};

export const openErrorDialog = (payload) => {
  return updateAlertDialog({
    open: true,
    error: true,
    ...payload,
  });
};

export const updateConfirmDialog = (payload) => {
  return { type: types.CONFIRM_DIALOG, payload };
};

export const closeConfirmDialog = () => {
  return updateConfirmDialog({ open: false });
};

export const openConfirmDialog = (payload) => {
  return updateConfirmDialog({
    open: true,
    ...payload,
  });
};



// WEBPACK FOOTER //
// ./src/actions/dialog/dialogActions.js